import { Button } from '@chakra-ui/react';
import { FormikErrors, FormikTouched } from 'formik';
import { t } from 'i18next';
import React from 'react'
import { useNavigate } from 'react-router-dom';
type profImage = {
  key: string;
  url: string;
  file?: any;
};
type formvalues = {
name: string;
value?: string;
placeHolder?: string;
    multiply?: string;
    urlImg?: profImage;
    active?: boolean;
};

interface PropsCardAppConfig {
handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
values: formvalues;
errors: FormikErrors<formvalues>;
touched: FormikTouched<formvalues>;
}

const CardAppConfig: React.FC<PropsCardAppConfig> = ({ handleChange, values, errors, touched }) => {
const navigate = useNavigate();

return (
  <div className="flex w-full flex-col justify-between gap-4">
    {/* Name Field */}
    <div className="mb-3 w-full">
      <label htmlFor="name" className="input-custom-label dark:text-white">
        {t("name")}
      </label>
      <input
        required
        style={{ backgroundColor: "rgba(242, 242, 242, 0.5)" }}
        className="mt-2 h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none"
        name="name"
        type="text"
        id="name"
        placeholder={t("EnterNameHere")}
        onChange={handleChange}
        value={values.name}
      />
      <div className="error-input">
        {errors.name && touched.name ? errors.name : null}
      </div>
    </div>

    {/* Value Field */}
    <div className="mb-3 w-full">
      <label htmlFor="value" className="input-custom-label dark:text-white">
        {t("value")}
      </label>
      <input
        required
        style={{ backgroundColor: "rgba(242, 242, 242, 0.5)" }}
        className="mt-2 h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none"
        name="value"
        type="text"
        id="value"
        placeholder={t("EnterValueHere")}
        onChange={handleChange}
        value={values.value}
      />
      <div className="error-input">
        {errors.value && touched.value ? errors.value : null}
      </div>
    </div>

    {/* Placeholder Field */}
    <div className="mb-3 w-full">
      <label htmlFor="placeHolder" className="input-custom-label dark:text-white">
        {t("placeHolder")}
      </label>
      <input
        required
        style={{ backgroundColor: "rgba(242, 242, 242, 0.5)" }}
        className="mt-2 h-12 w-full rounded-xl border bg-white/0 p-3 text-sm outline-none"
        name="placeHolder"
        type="text"
        id="placeHolder"
        placeholder={t("EnterPlaceHolderHere")}
        onChange={handleChange}
        value={values.placeHolder}
      />
      <div className="error-input">
        {errors.placeHolder && touched.placeHolder ? errors.placeHolder : null}
      </div>
    </div>
    {/* Active Checkbox Field */}
    <div className="mb-3 w-full">
      <div className="flex items-center gap-2">
        <input
          id="active"
          name="active"
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
          onChange={handleChange}
          checked={values.active}
        />
        <label htmlFor="active" className="input-custom-label dark:text-white mb-0">
          {t("active")}
        </label>
      </div>
      <div className="error-input">
        {errors.active && touched.active ? errors.active : null}
      </div>
    </div>

    {/* Buttons */}
    <div className="mt-auto flex gap-2">
      <Button
        // style={{backgroundColor: 'red'}}
        className="cancel-button mx-2"
        size="sm"
        onClick={() =>
          navigate(`/admin/settings/general`)
        }
      >
        {t("back")}
      </Button>
      <Button
        type='submit'
        className="
              text-white           
              text-[14px]           
              font-semibold        
              w-[150px]            
              py-2                
              px-2                 
              rounded-[5px]         
              bg-primary            
              hover:bg-red-600     
              transition-colors     
            "
                  >
        {t("save")}
      </Button>

    </div>
  </div>
);
};

export default CardAppConfig;
